/* Matrix PDP — interactions for the matrix-* sections (Skin Matrix Cream test PDP).
   Covers: complex tabs, hallmarks grid, INCI modal incl. search + category filter.
   Idempotent per section (data-mx-init guard) so it survives theme editor reloads. */
(function () {
  'use strict';

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mx-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mx-panel]'));
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-mx-panel') !== tab.getAttribute('data-mx-tab'); });
      });
    });
  }

  function initHallmarks(root) {
    var cells = Array.prototype.slice.call(root.querySelectorAll('[data-mx-hallmark]'));
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-mx-hallmark-detail]'));
    if (!cells.length) return;
    cells.forEach(function (cell) {
      cell.addEventListener('click', function () {
        var id = cell.getAttribute('data-mx-hallmark');
        cells.forEach(function (c) { c.setAttribute('aria-selected', c === cell ? 'true' : 'false'); });
        details.forEach(function (d) { d.hidden = d.getAttribute('data-mx-hallmark-detail') !== id; });
      });
    });
  }

  function initModal(root) {
    var dialogs = Array.prototype.slice.call(root.querySelectorAll('dialog[data-mx-modal]'));
    if (!dialogs.length) return;
    root.querySelectorAll('[data-mx-modal-open]').forEach(function (btn) {
      // keyed buttons (data-mx-modal-open="x") target dialog[data-mx-modal="x"],
      // unkeyed buttons target the section's first dialog
      var key = btn.getAttribute('data-mx-modal-open');
      var dialog = key
        ? root.querySelector('dialog[data-mx-modal="' + key + '"]')
        : dialogs[0];
      if (!dialog) return;
      btn.addEventListener('click', function () { dialog.showModal(); });
    });
    dialogs.forEach(function (dialog) {
      dialog.querySelectorAll('[data-mx-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { dialog.close(); });
      });
      // close on backdrop click
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
    });
  }

  function normalize(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function initInci(root) {
    var search = root.querySelector('[data-mx-inci-search]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-mx-inci-filter]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mx-inci-item]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mx-inci-tab]'));
    var count = root.querySelector('[data-mx-inci-count]');
    var empty = root.querySelector('[data-mx-inci-empty]');
    if (!items.length) return;

    // Duo PDPs render two lists (data-mx-inci-set 1/2) switched via tabs;
    // single PDPs have no tabs and state.set stays '' (no set filtering).
    var state = { q: '', cat: '', set: tabs.length ? '1' : '' };

    function apply() {
      var visible = 0;
      var total = 0;
      items.forEach(function (item) {
        var inSet = !state.set || item.getAttribute('data-mx-inci-set') === state.set;
        if (inSet) total++;
        var matchesCat = !state.cat || item.getAttribute('data-mx-inci-cat') === state.cat;
        var matchesQ = !state.q || normalize(item.textContent).indexOf(state.q) !== -1;
        var show = inSet && matchesCat && matchesQ;
        item.hidden = !show;
        if (show) visible++;
      });
      if (count) {
        count.textContent = visible + ' von ' + total + ' Inhaltsstoffen';
      }
      if (empty) empty.hidden = visible !== 0;
    }

    // Hide category chips that would be empty on the active tab; if the
    // active chip disappears, fall back to "Alle".
    function syncFilters() {
      if (!state.set) return;
      var activeGone = false;
      filters.forEach(function (btn) {
        var inSets = btn.getAttribute('data-mx-inci-in');
        var show = inSets === null || (',' + inSets + ',').indexOf(',' + state.set + ',') !== -1;
        btn.hidden = !show;
        if (!show && state.cat === btn.getAttribute('data-mx-inci-filter')) activeGone = true;
      });
      if (activeGone) {
        state.cat = '';
        filters.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mx-inci-filter') === '' ? 'true' : 'false'); });
      }
    }

    if (search) {
      search.addEventListener('input', function () {
        state.q = normalize(search.value.trim());
        apply();
      });
    }
    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.cat = btn.getAttribute('data-mx-inci-filter');
        filters.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        apply();
      });
    });
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.set = btn.getAttribute('data-mx-inci-tab');
        tabs.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        syncFilters();
        apply();
      });
    });
    syncFilters();
    apply();
  }

  function initGallery(root) {
    var scroller = root.querySelector('[data-mx-gallery]');
    if (!scroller) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mx-dot]'));
    var prev = root.querySelector('[data-mx-gallery-prev]');
    var next = root.querySelector('[data-mx-gallery-next]');
    var count = scroller.children.length;

    function index() {
      return Math.round(scroller.scrollLeft / scroller.clientWidth);
    }
    function goTo(i) {
      i = Math.max(0, Math.min(count - 1, i));
      scroller.scrollTo({ left: i * scroller.clientWidth, behavior: 'smooth' });
    }
    function sync() {
      var i = index();
      dots.forEach(function (d, di) {
        if (di === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= count - 1;
    }

    var raf = null;
    scroller.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { goTo(di); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    sync();
  }

  /* matrix-claims: count up the stat values and grow the per-row meter bars
     once the rows scroll into view. Values are strings like "−20,6 %" (unicode
     minus, comma decimals) — only the numeric part is animated, prefix/suffix
     stay as authored. */
  function initClaims(root) {
    var values = Array.prototype.slice.call(root.querySelectorAll('[data-mx-count]'));
    if (!values.length) return;

    var NUM_RE = /\d+(?:[.,]\d+)?/;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var parsed = values.map(function (el) {
      var text = el.textContent;
      var m = text.match(NUM_RE);
      if (!m) return null;
      var raw = m[0];
      var decimals = (raw.match(/[.,](\d+)/) || [, ''])[1].length;
      var sep = raw.indexOf(',') !== -1 ? ',' : '.';
      return {
        el: el,
        prefix: text.slice(0, m.index),
        suffix: text.slice(m.index + raw.length),
        target: parseFloat(raw.replace(',', '.')),
        decimals: decimals,
        sep: sep,
        bar: (el.closest('.mx-claims__row') || el).querySelector('.mx-claims__bar')
      };
    }).filter(Boolean);

    var max = parsed.reduce(function (acc, p) { return Math.max(acc, Math.abs(p.target)); }, 0);

    function barWidth(p) {
      if (!max) return 0;
      return Math.round(30 + 65 * (Math.abs(p.target) / max));
    }

    function setFinal(p) {
      if (p.bar) p.bar.style.width = barWidth(p) + '%';
    }

    function animate(p) {
      // lock the measured width so the shared column doesn't jitter mid-count
      p.el.style.minWidth = p.el.getBoundingClientRect().width + 'px';
      var start = null;
      var DURATION = 1100;
      function frame(ts) {
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / DURATION);
        var eased = 1 - Math.pow(1 - t, 3);
        var current = (p.target * eased).toFixed(p.decimals).replace('.', p.sep);
        p.el.textContent = p.prefix + current + p.suffix;
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
      setFinal(p);
    }

    if (reduce || !('IntersectionObserver' in window)) {
      parsed.forEach(setFinal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var p = parsed.filter(function (x) { return x.el === entry.target; })[0];
        if (p) animate(p);
      });
    }, { threshold: 0.6 });
    parsed.forEach(function (p) { io.observe(p.el); });
  }

  /* Adaptive nav contrast: the transparent header sits on the hero gallery, so
     we sample the visible slide's top strip (the area under the menu) and flip
     the nav to white (.mx-nav-light on <html>) when the image is dark. Default
     without the class is the dark nav (right for light studio shots + no-JS).
     Shopify CDN serves CORS headers, so canvas sampling works cross-origin. */
  function initHeaderContrast(root) {
    var gallery = root.querySelector('[data-mx-gallery]');
    if (!gallery || !document.querySelector('x-header.header')) return;
    var rootEl = document.documentElement;
    var cache = {};

    function apply(lum) {
      rootEl.classList.toggle('mx-nav-light', lum < 0.55);
    }

    function sample() {
      var i = Math.max(0, Math.round(gallery.scrollLeft / gallery.clientWidth));
      var slide = gallery.children[i] || gallery.children[0];
      var img = slide && slide.querySelector('img');
      var src = img && (img.currentSrc || img.src);
      if (!src) { apply(1); return; }
      if (cache[src] != null) { apply(cache[src]); return; }
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        var lum = 1;
        try {
          var c = document.createElement('canvas');
          c.width = 16;
          c.height = 8;
          var ctx = c.getContext('2d');
          /* Underlay the gallery background first: PNGs with transparency
             would otherwise count their transparent pixels as black and
             wrongly flip the nav to white on a light page. */
          var bg = '#ddd8cf';
          try { bg = getComputedStyle(gallery).backgroundColor || bg; } catch (e2) { /* keep fallback */ }
          ctx.fillStyle = bg;
          ctx.fillRect(0, 0, 16, 8);
          ctx.drawImage(probe, 0, 0, probe.naturalWidth, Math.max(1, probe.naturalHeight * 0.3), 0, 0, 16, 8);
          var d = ctx.getImageData(0, 0, 16, 8).data;
          var sum = 0;
          for (var k = 0; k < d.length; k += 4) {
            sum += 0.2126 * d[k] + 0.7152 * d[k + 1] + 0.0722 * d[k + 2];
          }
          lum = sum / (d.length / 4) / 255;
        } catch (e) { /* tainted canvas -> keep dark nav */ }
        cache[src] = lum;
        apply(lum);
      };
      probe.onerror = function () { apply(1); };
      probe.src = src;
    }

    var t = null;
    gallery.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(sample, 150);
    }, { passive: true });
    sample();
  }

  function initSection(root) {
    if (root.hasAttribute('data-mx-init')) return;
    root.setAttribute('data-mx-init', '');
    initTabs(root);
    initHallmarks(root);
    initModal(root);
    initInci(root);
    initGallery(root);
    initClaims(root);
    initHeaderContrast(root);
  }

  function initAll() {
    document.querySelectorAll('[data-mx-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init after section re-render
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-mx-section]').forEach(initSection);
    var self = e.target.matches && e.target.matches('[data-mx-section]');
    if (self) initSection(e.target);
  });
})();
